export default [
	{
		logo: '/img/reviews/marker/ceo-photo.png',
		customer: {
			name: 'Сергей Писоцкий',
			post: 'Генеральный директор “MARKER GROUP”',
			contactLink: 'tel: +38 (067) 230-75-77',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `Разработка приложения под iOS и Android для анализа главных показателей рынка минеральных удобрений.`,
		coopDuration: `С 2019 года по настоящий момент`,
		shortQuote: `Редкий пример аутсорса, который действительно становится частью твоей команды!`,
		content: `
      <p>Global Code — редкий пример аутсорса, который действительно становится частью твоей команды. Ребята заинтересованы в достижении твоих бизнес целей, в увеличении твоей рыночной эффективности и уникальности.</p>
      <p>Отдельно хочу выделить три момента, отличающие опыт работы с Global Code от предыдущих опытов.</p>
      <h3>Коммуникация</h3>
      <p>То, с чего начинается любая работа. Особенно это важно для сферы, где ты не имеешь достаточной компетенции. Ещё она усугубляется тем, что твоя задача не имеет аналогов и кальки. </p>
      <p>Коммуникация изначально профессиональна, структурирована, на понятном языке и направлена на достижение наилучшего результата. Мне не нужно повторяться и напоминать. Не нужно «подрабатывать» секретарем у технарей. Не нужно общаться с дополнительным словарем, чтобы переводить сказанное.</p>
      <h3>Отношение</h3>
      <p>Отношение к твоему проекту настолько инициативное и вовлеченное, что команда становится составной частью твоей компании. Работа не формальна и не шаблонна, предлагаются различные варианты и рецепты, чтобы достичь наилучшего результата. В этом есть и рациональный смысл — компания предлагает широкий диапазон услуг, в том числе и продвижение твоего продукта на рынок. Поэтому, чем лучше, чем уникальнее продукт будет, — тем проще и легче будет работать с ним в дальнейшем.</p>
      <h3>Профессионализм</h3>
      <p>Собственно, первые два пункта уже являются составной частью того, что я считаю профессионализмом. Остаётся добавить, что на выходе есть результат и он отличный! Лучше, чем ты рассчитывал вначале. И в обозначенный срок, что очень важно. </p>
      <p>Как итог, компания «Global code» делает упор на долгосрочную работу и расширение/углубление уровня сотрудничества. Поэтому ребята заинтересованы в достижении твоих бизнес целей, в увеличении твоей рыночной эффективности и уникальности. Редкий пример аутсорса, который действительно становится частью твоей команды!</p>
    `,
		images: [
			'/img/reviews/marker/1.png',
			'/img/reviews/marker/2.png',
			'/img/reviews/marker/3.png',
			'/img/reviews/marker/4.png',
			'/img/reviews/marker/5.png',
		],
		// site: '',
		appstore: 'https://apps.apple.com/ru/app/marker-ap/id1451579856',
		googleplay:
			'https://play.google.com/store/apps/details?id=info.markergroup.android&hl=ru&gl=US',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},

	{
		logo: '/img/reviews/vfinterior/ceo-photo.png',
		customer: {
			name: 'Виктория Филимонова',
			post: 'Основатель “Victoria Filimonova interior designer”',
			contactLink: 'tel: +7 (920) 210-38-11',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `Сделать стильный сайт, понятный и доступный любому, но обязательно нестандартный и неповторимый.`,
		coopDuration: `С 2019 года по настоящий момент`,
		shortQuote: `На одной волне провели всю работу над продуктом от начала и до конца`,
		content: `
      <p>Необходимость создания сайта возникла не спонтанно, я уже давно об этом задумывалась и вела переговоры с ребятами из Global Code. Мы все согласовали: сроки, стоимость, организационные моменты и приступили к работе. </p>
      <p>Не ожидала, что все ребята, работающие над моим проектом, проявят себя так ответственно и добросовестно! Работать было очень легко: ответы на вопросы, решение каких-либо моментов, проверка финального продукта, все на высшем уровне! Мы "на одной волне" провели всю работу над продуктом от начала и до конца. Поэтому и сайт превзошёл все мои ожидания, получился "бомбическим"! Благодаря этому уровень моей компании значительно вырос, что прибавило мне клиентов.</p>
      <p>Искренне буду рекомендовать ребят и желаю им только успехов в дальнейших проектах!</p>
    `,
		images: [
			'/img/reviews/vfinterior/1.png',
			'/img/reviews/vfinterior/2.png',
			'/img/reviews/vfinterior/3.png',
			'/img/reviews/vfinterior/4.png',
			'/img/reviews/vfinterior/5.png',
		],
		site: 'https://vfinterior.ru/',
		// appstore: '',
		// googleplay: '',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},

	{
		logo: '/img/reviews/new-alaska/logo.png',
		customer: {
			name: 'Кирилл Валерьевич',
			post: 'Генеральный директор ООО "Новая Аляска Волхов"',
			contactLink: 'tel: +7 (921) 934-15-06',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `
      <ol>
        <li>Редизайн сайта и разработка мобильной версии.</li>
        <li>Экспертные статьи и описания товаров на русском и английском языке.</li>
        <li>Создание интерактивной карты поставок.</li>
      </ol>
    `,
		coopDuration: `С 2016 года по настоящий момент (периодические задачи по поддержке сайта)`,
		shortQuote: `Творческий, обширный и технологичный подход`,
		content: `
      <p>
        <b>— С какими задачами вы обратились в Global Code?</b><br>
        — Разработка дизайна сайта, продвижение и поддержка сайта.
      </p>
      <p>
        <b>— Как давно сотрудничаете с нами?</b><br>
        — С 2016 года
      </p>
      <p>
        <b>— Что ценного наша работа привнесла в ваш бизнес?</b><br>
        — Презентабельное представление нашей компании в интернете
      </p>
      <p>
        <b>— Что вас больше всего впечатлило в работе нашей команды?</b><br>
        — Четкость, прозрачность, умение объяснить и донести необходимость того или иного решения
      </p>
        <p>
        <b>— Какие сильные стороны Global Code вы могли бы выделить?</b><br>
        — Творческий, обширный и технологичный подход, знание многих вопросов в данной области
      </p>
      <p>
        <b>— Для решения каких задач вы бы порекомендовали нас знакомым?</b><br>
        — Для решения комплексных задач компании в представлении и продвижении в интернете
      </p>
    `,
		images: [
			'/img/reviews/new-alaska/1.png',
			'/img/reviews/new-alaska/2.png',
			'/img/reviews/new-alaska/3.png',
			'/img/reviews/new-alaska/4.png',
		],
		site: 'http://www.newalaskavolkhov.ru/',
		// appstore: '',
		// googleplay: '',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},
]
